// 帖子相关的 Action 层，负责业务逻辑和异步操作
import { action, makeObservable, runInAction } from 'mobx';
import { ProductStore } from './store';
import { readProductList, readProductMyList, readProductDetail, readProductCode, submitProductCodeExchange, readInviteLinkCreate, submitProductEnroll } from '@server';


export class ProductAction extends ProductStore {

    constructor(props) {
        super(props);
        makeObservable(this);
    }

    /**
         * 获取新品众测列表（异步）
         * 统一管理 loading、错误、分页、hasMore 等状态
         * 页面和 list 组件可直接响应 listStore 的状态
         * @param {object} params 查询参数
         *   - params.page[number]: 页码
         *   - params.page[size]: 每页数量
         *   - params.filter: 过滤条件（可选）
         * @returns {Promise<void>}
         */
    
    
        @action
        async getProductList(params) {
            runInAction(() => {
                this.listStore.setAttribute({ namespace: 'productList', key: 'loading', value: true });
            });
            const res = await readProductList(params);
            runInAction(() => {
                // console.log('product list response:', res, 'Params:', params);
                if (res.code === 0) {
                    // 适配新格式：数据在 res.data.data，分页在 res.data.page
                    const productData = res.data && res.data.data ? res.data.data : res.data;
                    const pageInfo = res.data && res.data.page ? res.data.page : {};
                    
                    this.listStore.setList({
                        namespace: 'productList',
                        data: { data: productData },
                        path: 'data',
                        page: params.page || params['page[number]'] || pageInfo.number || 1,
                        search: { filter: params.filter || {} },
                        hasMore: pageInfo.hasMore !== undefined ? pageInfo.hasMore : false,
                    });
                    this.listStore.setAttribute({ namespace: 'productList', key: 'requestError', value: { isError: false, errorText: '' } });
                } else {
                    this.listStore.setAttribute({ namespace: 'productList', key: 'requestError', value: { isError: true, errorText: res.message || '加载失败' } });
                }
                this.listStore.setAttribute({ namespace: 'productList', key: 'loading', value: false });
            });
            // console.log('这是活动列表呀', res);
            return res
        }

        
        /**
     * 获取用户收藏活动列表（异步）
     * 统一管理 loading、错误、分页、hasMore 等状态
     * 页面和 list 组件可直接响应 listStore 的状态
     * @param {object} params 查询参数
     *   - params.page[number]: 页码
     *   - params.page[size]: 每页数量
     *   - params.filter: 过滤条件（可选）
     * @returns {Promise<void>}
     */
    @action
    async getProductMyList(params) {
        runInAction(() => {
            this.listStore.setAttribute({ namespace: 'productMyList', key: 'loading', value: true });
        });
        const res = await readProductMyList(params);
        runInAction(() => {
            console.log('product favorite list response:', res, 'Params:', params);
            if (res.code === 0) {
                // 适配新格式：数据在 res.data.data，分页在 res.data.page
                const productData = res.data && res.data.data ? res.data.data : res.data;
                const pageInfo = res.data && res.data.page ? res.data.page : {};
                
                this.listStore.setList({
                    namespace: 'productMyList',
                    data: { data: productData },
                    path: 'data',
                    page: params.page || params['page[number]'] || pageInfo.number || 1,
                    search: { filter: params.filter || {} },
                    hasMore: pageInfo.hasMore !== undefined ? pageInfo.hasMore : false,
                });
                this.listStore.setAttribute({ namespace: 'productMyList', key: 'requestError', value: { isError: false, errorText: '' } });
            } else {
                this.listStore.setAttribute({ namespace: 'productMyList', key: 'requestError', value: { isError: true, errorText: res.message || '加载失败' } });
            }
            this.listStore.setAttribute({ namespace: 'productMyList', key: 'loading', value: false });
        });
        // console.log('这是我的产品列表', res);
        return res
    }

    /**
     * 直接设置 productList（通常不推荐，建议用 listStore 统一管理）
     * @param {array} productList 产品列表
     */
    @action
    setProductList(productList) {
        this.productList = productList;
    }

    /**
     * 直接设置 productMyList（通常不推荐，建议用 listStore 统一管理）
     * @param {array} productMyList 我的产品列表
     */
    @action
    setProductMyList(productMyList) {
        this.productMyList = productMyList;
    }

    /**
     * 设置 productData
     * @param {object} data 产品详情数据
     */
    @action
    setProductData(data) {
        this.productData = { ...this.productData, ...data };
        this.productData.id = data.id;
    }

    /**
     * 获取产品详情
     * @returns 产品详细信息
     */
    @action
    async getProductDetail(params = {}) {
        const ret = await readProductDetail(params);
        
        if (ret.code === 0) this.setProductData(ret.data);
        return ret;
    }

    /**
     * 获取我的试用码
     * @returns 试用码信息
     */
    @action
    async getProductCode(params = {}) {
        const ret = await readProductCode(params);
        return ret;
    }
    
    /**
     * 积分兑换试用码
     */
    async submitProductCodeExchangeData(params) {
        const res = await submitProductCodeExchange(params);
        return res
    }

    /**
     * 获取我的试用码
     * @returns 试用码信息
     */
    @action
    async getInviteLinkCreate(params) {
        const ret = await readInviteLinkCreate(params);
        return ret;
    }
    
    /**
     * 产品试用报名接口
     */
    async submitProductEnrollData(params) {
        const res = await submitProductEnroll(params);
        return res
    }
    
    
}


// 单例导出，方便全局调用
const productAction = new ProductAction();
export default productAction;